import { safeDefine } from "../../registration/safe-define.js";
import { CompatLiveAudioSkinElement } from "../../presets/live-audio/compat-skin.js";
import "../../internal/skins/compat-live-audio/register.js";
//#region src/define/live-audio/compat-skin.ts
safeDefine(CompatLiveAudioSkinElement);
//#endregion

//# sourceMappingURL=compat-skin.js.map